import Vue from 'vue';
import VueRouter from 'vue-router';

import home from './home.js';
import player from './player.js';
import trainingCamp from './training-camp.js';
import assemble from './assemble.js';
import scoutReport from './scout-report';
Vue.use(VueRouter);
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

let allRoutes = [
  ...home,
  ...player,
  ...trainingCamp,
  ...assemble,
  ...scoutReport,
];

export default new VueRouter({
  mode: 'hash',
  routes: [
    {
      path: '/',
      redirect: '/login',
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login'),
      meta: {
        title: '登录',
      },
    },
    {
      path: '/login-entry',
      name: 'login',
      component: () => import('@/views/login/login-entry'),
      meta: {
        title: '登录',
      },
    },
    {
      path: '/layout',
      name: 'layout',
      component: () => import('@/layout/index'),
      redirect: '/home',
      children: allRoutes,
    },
  ],
});
